import axios from "axios";
import isNil from "lodash/isNil";
import { useAxiosHook } from "./useAxiosHook";

const ROUTE_PREFIX = "property_address";

export const useAddressHook = () => {
  const {
    axiosPostIsLoading,
    isLoading,
    axiosGetIsLoading,
    axiosError,
    axiosPostRequest,
  } = useAxiosHook();

  const loading = isLoading || axiosGetIsLoading || axiosPostIsLoading;
  const error = axiosError;

  const createSubjectPropertyFromObject = async ({
    dealId,
    subjectPropertyId,
    addressObject,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/subjectProperty/create_from_object/${dealId}/${subjectPropertyId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(subjectPropertyId) || isNil(addressObject)) {
      console.error(
        "Deal ID, Subject Property ID, or address object is missing",
        {
          dealId,
          subjectPropertyId,
          addressObject,
        },
      );
      return;
    }

    await axiosPostRequest({
      name: "Create Subject Property Address from Object",
      path: endpoint,
      payload: { address_object: addressObject },
      cancelSource: source,
      onSuccessMsg: "Subject property address created successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const createSubjectPropertyFromString = async ({
    dealId,
    subjectPropertyId,
    addressString,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/subjectProperty/create_from_string/${dealId}/${subjectPropertyId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(subjectPropertyId) || isNil(addressString)) {
      console.error(
        "Deal ID, Subject Property ID, or address string is missing",
        {
          dealId,
          subjectPropertyId,
          addressString,
        },
      );
      return;
    }

    await axiosPostRequest({
      name: "Create Subject Property Address from String",
      path: endpoint,
      payload: { address_string: addressString },
      cancelSource: source,
      onSuccessMsg: "Subject property address created successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const updateSubjectPropertyAddress = async ({
    dealId,
    subjectPropertyId,
    addressObject,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/subjectProperty/update/${dealId}/${subjectPropertyId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(subjectPropertyId) || isNil(addressObject)) {
      console.error(
        "Deal ID, Subject Property ID, or address object is missing",
        {
          dealId,
          subjectPropertyId,
          addressObject,
        },
      );
      return;
    }

    await axiosPostRequest({
      name: "Update Subject Property Address",
      path: endpoint,
      // payload: { addressObject },
      payload: { address_object: addressObject },
      cancelSource: source,
      onSuccessMsg: "Subject property address updated successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
      // errorTesting: true,
    });
  };

  // Borrower Address Methods
  const createBorrowerAddressFromObject = async ({
    dealId,
    borrowerId,
    addressObject,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/borrower/create_from_object/${dealId}/${borrowerId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(borrowerId) || isNil(addressObject)) {
      console.error("Deal ID, Borrower ID, or address object is missing", {
        dealId,
        borrowerId,
        addressObject,
      });
      return;
    }

    await axiosPostRequest({
      name: "Create Borrower Address from Object",
      path: endpoint,
      payload: { address_object: addressObject },
      cancelSource: source,
      onSuccessMsg: "Borrower address created successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const createBorrowerAddressFromString = async ({
    dealId,
    borrowerId,
    addressString,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/borrower/create_from_string/${dealId}/${borrowerId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(borrowerId) || isNil(addressString)) {
      console.error("Deal ID, Borrower ID, or address string is missing", {
        dealId,
        borrowerId,
        addressString,
      });
      return;
    }

    await axiosPostRequest({
      name: "Create Borrower Address from String",
      path: endpoint,
      payload: { address_string: addressString },
      cancelSource: source,
      onSuccessMsg: "Borrower address created successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const updateBorrowerAddress = async ({
    dealId,
    borrowerId,
    addressObject,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    const endpoint = `${ROUTE_PREFIX}/borrower/update/${dealId}/${borrowerId}`;
    const source = axios.CancelToken.source();

    if (isNil(dealId) || isNil(borrowerId) || isNil(addressObject)) {
      console.error("Deal ID, Borrower ID, or address object is missing", {
        dealId,
        borrowerId,
        addressObject,
      });
      return;
    }

    await axiosPostRequest({
      name: "Update Borrower Address",
      path: endpoint,
      payload: { address_object: addressObject },
      cancelSource: source,
      onSuccessMsg: "Borrower address updated successfully",
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  return {
    error,
    loading,
    // Subject Property methods
    createSubjectPropertyFromObject,
    createSubjectPropertyFromString,
    updateSubjectPropertyAddress,
    // Borrower methods
    createBorrowerAddressFromObject,
    createBorrowerAddressFromString,
    updateBorrowerAddress,
  };
};
const e = {
  _id: "69a9c7877bada539975aba03",
  address: {
    address_object: {
      coordinateTuple: [40.866524, -73.435165],
      country: "United States",
      countryCode: "US",
      county: "NY",
      fullAddress: "128 Carley Avenue, Huntington, NY 11743",
      id: "LqQTGcK0fhM3tVZHJnnRTA-1775755398647",
      latitude: 40.866524,
      longitude: -73.435165,
      score: 0.9816712086344217,
    },
    city: "Huntington",
    coordinateTuple: [40.866112, -73.43475],
    country: "United States",
    countryCode: "US",
    county: "Suffolk",
    fullAddress: "128 Carley Ave, Huntington, NY 11743",
    id: "A-1yb5xFhzjCuSufdQxVXQ-1772734318823",
    latitude: 40.8666215,
    longitude: -73.4351722,
    score: 1,
    state: "NY",
    streetAddress: "125 Carley Avenue",
    streetName: "Carley Avenue",
    streetNumber: "125",
    zip: "11743",
  },
  arv: 2500000,
  asIsValue: 2000000,

  monthlyFloodInsurance: 0,
  monthlyHoaFees: 0,
  monthlyInsurance: 0,
  monthlyOtherExpense: 0,
  monthlyPropertyMgmtFees: 0,
  monthlyTaxes: 0,
  propertyRuralIndicator: false,
  propertyType: "SFR",
};
